// extracted by mini-css-extract-plugin
export var world_img = "styles-module--world_img--05c8f";
export var wrapper = "styles-module--wrapper--8cacd";